export default __webpack_public_path__ + "static/media/kems-right.46b4a634.svg";